<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      商品管理
      <small>
        /&nbsp;
        <router-link to="/goodslist" class="TitleStyle">商品列表</router-link>&nbsp;/&nbsp;同步
      </small>
    </h1>
    <!-- end col-6 -->
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">同步列表</h4>
              </div>
               <div class="panel-body">
              <!-- end panel-heading -->
            <el-table
          ref="multipleTable"
          :data="UserManagementList"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="id" label="商品ID" align="center"></el-table-column>
          <el-table-column prop="pznCode" label="商品编号" align="center"></el-table-column>
          <el-table-column prop="goodsName" label="商品名称"  header-align="center" show-overflow-tooltip></el-table-column>
<!--         
            <el-table-column prop="address" label="是否含税"></el-table-column> -->
          <el-table-column prop="taxRate" label="税率" align="center"></el-table-column>
          <el-table-column prop="placeOfOriginCode" label="原产国代码" align="center"></el-table-column>
      
          <el-table-column prop="placeOfOriginName" label="原产国名称"  header-align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="specs" label="商品规格" align="center"></el-table-column>
         <el-table-column prop="weight" label="毛重" align="center"></el-table-column>
          <el-table-column prop="netWeight" label="净重" align="center"></el-table-column>
          <el-table-column prop="barCode" label="条形码" align="center"></el-table-column>
        </el-table>
         <div class="PaginationStyle">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageindexs"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSizes"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="totalCount"
                  ></el-pagination>
                </div>
                <div class="clear"></div>
        <div class="swal-footer" style="text-align:right"> 
           <div class="swal-button-container">
            <div class="swal-button swal-button--confirm btn btn-primary" @click="MakeSure">确定</div>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="Goback"
            >取消</div>
          </div>
        
        </div>
               </div>
            </div>
            <!-- end panel -->
          </div>     
     
          <!-- end col-10 -->
        </div>    
  
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>

  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "@/common/http";

export default {
  name: "InfoSynchronization",
  data() {
    return {
       pageSizes:10,
       pageindexs:1,
       pageindex:1,
       pageSize:10,
       totalCount:0,
       CurrentSelect:[
         {
            id: '',
            pznCode: '',
            goodsName: '',
            unit: '',
            taxrate: '',
            placeOfOriginCode: '',
            specs: '',
           weight: '',
           netWeight: '',
         barCode: ''
         }
       ],
        UserManagementList:[
       ],
       director:0
    };
  },
  mounted: function() {
    // if(this.$route.query.director){
    //   this.director = this.$route.query.director;
    // }
    this.initdata();
  },
  methods: {
   handleSizeChange(val) {
      this.pageSizes = val;
      this.pageindexs = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindexs = val;
      this.initdata();
    },
    initdata() {
        if (localStorage.getItem("goodlist")) {
        let goodlist = localStorage.getItem("goodlist");
        this.goodsId = JSON.parse(goodlist).goodsId;
        this.pageNo = JSON.parse(goodlist).pageNo;
        this.pageSize = JSON.parse(goodlist).pageSize;
        }
       let that = this;
   
      const options = {
        url: "distribution/B2cGoodsInfoController/queryGoodsInfoListByZT",
        method: "post",
        headers: { "Content-Type": "application/json" },
        data: {
          director:that.director,
          size: that.pageSizes,
          current: that.pageindexs
        }
      };
      axios(options).then(function(response) {
        if (response.data.code == 200) {
          that.totalCount = response.data.data.total;
          for (var i in response.data.data.records) {
            response.data.data.records[i].ordernumber =
              Number((that.pageindexs - 1) * that.pageSizes) + Number(i) + 1;
     
          }

          that.UserManagementList = response.data.data.records;
        } else {
           http.handleEorrorCode(response,that);
        }
      })
            .catch(function(error) {
                
              
                http.handleHttpError(error, that);
              });
    },
     handleSelectionChange(val) {
       this.CurrentSelect = val;
     
     },
     
     MakeSure(){

        let that = this;
       console.log(that.CurrentSelect)
      const options = {
        url: "distribution/B2cGoodsInfoController/synGoodsInfo",
        method: "post",
        headers: { "Content-Type": "application/json" },
        data: {
         goodsInfoSynList: that.CurrentSelect
        }
      };
      axios(options).then(function(response) {
        that.initdata();
        if (response.data.code == 200) {
           that.$notify({
            title: "成功",
            message: response.data.message,
            type: "success"
          });
          
        } else {
          http.handleEorrorCode(response,that);
        }
      })
            .catch(function(error) {
                
              
                http.handleHttpError(error, that);
              });
     },
     Goback(){
        this.$router.push({ name: "GoodsList" , params: { pageNo : this.pageNo , pagesize:this.pageSize}});
     }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ModelPadding {
  margin-top: -30px;
}
.LineSpacing {
  margin-top: 16px;
}
.ButtonColor {
  color: #fff !important;
}

.OrderInfo {
  padding: 20px 30px;
}
.GTitle {
  border-top: 3px #84caf3 solid;
  overflow: hidden;
  line-height: 25px;
  border-right: 1px #e5e5e5 solid;
  background: #f4f4f4;
}
.TInfo {
  position: relative;
  min-width: 130px;
  float: left;
  font-size: 16px;
  padding: 5px 15px;
  background-color: #84caf3;
  color: #ffffff;
}
.GContent {
  padding: 15px;
  border: 1px #e5e5e5 solid;
  border-top: none;
}

.TitleStyle {
  color: #6a7786;
}
@media screen and (min-width:1360px) and (max-width:1680px){ /*二栏布局*/ .TableContent{width: 50%;}  }
@media screen and (min-width:1680px) and (max-width:2000px){ /*二栏布局*/ .TableContent{width: calc(100%/3);}  }
.TableContent {
  float: left;
}
.GContentUl {
  list-style: none;
}
.TCode {
  color: #999999;
  text-align: left;
  display: inline-block;
  width: 105px;
  overflow: hidden;
  font-size: 14px;
  float: left;
  padding-left: 16px;
  padding-top:8px;
  padding-bottom: 8px;
}
.TCodeContent {
  font-size: 12px;
  float: left;
  width: calc(100% - 105px);
  line-height: 20px;
  text-align: left;
  word-break: normal;
  word-wrap: break-word;
  padding-top:8px;
  padding-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/CommoditiesList/InfoSynchronization.vue